import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CustomMaterialPipe } from '@app/baseBtl/base/pipes/custom-material.pipe';
import { ComponentsModule } from '@app/trilogy/components.module';

import { TranslateModule } from '@ngx-translate/core';

import { FormFeedbackComponent } from '../baseBtl/base/components/form-feedback/form-feedback.component';
import { CirclesLoaderDirective } from '../baseBtl/base/directives/circles-loader.directive';
import { TrustHtmlPipe } from '../baseBtl/base/pipes/trustHtml.pipe';
import { CookiesOptions } from './classes/cookies-options.class';
import { CmsBlockComponent } from './components/cms-block/cms-block.component';
import { ContainerBasicModule } from './components/container-basic/container.module';
import { ContainerLightModule } from './components/container-light/container.module';
import { FormMessagesComponent } from './components/form-messages/form-messages.component';
import { HeaderLightComponent } from './components/header-light/header-light.component';
import { LegalsTextComponent } from './components/legals-text/legals-text.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { BtlTranslateDirective } from './directives/btl-translate.directive';
import { CustomMaskDirective } from './directives/custom-mask.directive';
import { FormCustomValues } from './directives/form-custom-values.directive';
import { UrlPictureDirective } from './directives/image-url.directive';
import { SvgDirective } from './directives/svg.directive';
import { ToggleBodyClassDirective } from './directives/toggle-body-class.directive';
import { BtlTranslatePipe } from './pipe/btl-translate.pipe';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        ContainerLightModule,
        TranslateModule,
        ContainerBasicModule,
        ComponentsModule,
    ],
    declarations: [
        PageTitleComponent,
        HeaderLightComponent,
        SvgDirective,
        CirclesLoaderDirective,
        CustomMaskDirective,
        CmsBlockComponent,
        FormFeedbackComponent,
        FormMessagesComponent,
        FormCustomValues,
        LegalsTextComponent,
        TrustHtmlPipe,
        BtlTranslateDirective,
        BtlTranslatePipe,
        ToggleBodyClassDirective,
        CustomMaterialPipe,
        UrlPictureDirective,
    ],
    exports: [
        PageTitleComponent,
        SvgDirective,
        CirclesLoaderDirective,
        CmsBlockComponent,
        FormFeedbackComponent,
        ContainerLightModule,
        ContainerBasicModule,
        ComponentsModule,
        HeaderLightComponent,
        FormMessagesComponent,
        FormCustomValues,
        CustomMaskDirective,
        LegalsTextComponent,
        TrustHtmlPipe,
        BtlTranslateDirective,
        BtlTranslatePipe,
        TranslateModule,
        ToggleBodyClassDirective,
        CustomMaterialPipe,
        UrlPictureDirective,
    ],
})
export class SharedForAllModule {
    static forRoot(): ModuleWithProviders<SharedForAllModule> {
        return {
            ngModule: SharedForAllModule,
            providers: [
                {
                    provide: CookiesOptions,
                    useValue: {},
                },
            ],
        };
    }
}
